import { render, staticRenderFns } from "./DeleteErrorModal.vue?vue&type=template&id=8bdad46c&scoped=true"
import script from "./DeleteErrorModal.vue?vue&type=script&lang=js"
export * from "./DeleteErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdad46c",
  null
  
)

export default component.exports